import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { Representation } from '../../../api/app-types/representation.app';

@Component({
	selector: 'lvr-sidebar-settings-menu',
	standalone: true,
	imports: [MatButtonModule, MatIconModule, MatMenuModule, RouterModule, TranslocoPipe],
	templateUrl: './sidebar-settings-menu.html',
	styleUrl: './sidebar.scss',
})
export class SidebarSettingsMenu {
	public readonly representations = input<Representation[]>([]);
	public readonly representationsLoading = input(false);
	public readonly canReceiveRepresentation = input(true);

	public readonly loadRepresentations = output<void>();
	public readonly selectRepresentative = output<Representation>();
	public readonly logout = output<void>();

	public onLoadRepresentations() {
		this.loadRepresentations.emit();
	}

	public onSelectRepresentative(user: Representation) {
		this.selectRepresentative.emit(user);
	}

	public onLogout() {
		this.logout.emit();
	}

	public getUserLabel(user: Representation) {
		const name = `${user.firstName} ${user.lastName}`.trim();
		return name || user.displayName;
	}
}
